import { makeStyles } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import config from 'shared/config';
import StartForm from '../Form/Implementations/EmailForm';
import { validateEmail } from '../Form/Validation';
import PageTemplate from '../PageTemplate';
import commonStyles from '../styles';
import { IRegistrationProps } from './IRegistrationProps';

interface Props extends IRegistrationProps {
  email: string;
  setEmail(email: string): void;
}

const RegistrationStart = ({ email, handleNext, nextButtonContent, setEmail }: Props): ReactElement => {
  const { t } = useTranslation();
  const { link } = makeStyles((theme) => createStyles(commonStyles(theme)))();
  const isEmailValid = validateEmail(email);
  const error = Boolean(!email) || isEmailValid ? '' : t('profile.email.error');
  const { baseUrl } = config;

  return (
    <PageTemplate
      title={t('auth.new.user.registration')}
      description={t('auth.your.email.use')}
      form={<StartForm email={email} handleChange={setEmail} isEmailValid={isEmailValid} error={error} />}
      hint={
        <>
          {t('auth.you.agree.with')}{' '}
          <a className={link} href={`${baseUrl}/eula.pdf`} target="_blank" rel="noopener noreferrer">
            {t('auth.eula')}
          </a>{' '}
          {t('auth.and.confirm')}{' '}
          <a className={link} href={`${baseUrl}/policy.pdf`} target="_blank" rel="noopener noreferrer">
            {t('auth.pers.data.policy')}
          </a>{' '}
          {t(`and`)}{' '}
          <a className={link} href={`${baseUrl}/content.pdf`} target="_blank" rel="noopener noreferrer">
            {t('auth.service.rules')}
          </a>
        </>
      }
      submitButtonContent={nextButtonContent}
      submit={handleNext}
      disableSubmit={Boolean(!email || !isEmailValid)}
    />
  );
};

export default RegistrationStart;
